'use strict';

/** @type {import('.')} */
module.exports = Object;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-object-atoms/index.js
 ** module id = 936
 ** module chunks = 0
 **/